<template>
  <div class="page-popups-layer" :style="{zIndex: zi}">
    <tutorialVideoPopup></tutorialVideoPopup>
    <AnimCourse></AnimCourse>
    <version-update></version-update>
  </div>
</template>

<script>
import tutorialVideoPopup from './tutorialVideoPopup.vue';
import AnimCourse from '../AnimCourse.vue'
import versionUpdate from '../popups/versionUpdatePopup.vue';
export default {
  components: {
    tutorialVideoPopup,
    AnimCourse,
    versionUpdate
  },
  data() {
    return {
      zi: ""
    };
  },

};
</script>

<style lang="scss" scoped>
page-popups-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  z-index: 30;
}
</style>



// WEBPACK FOOTER //
// src/components/pagePopups/pagePopupsLayer.vue